import { render, staticRenderFns } from "./SummaryContent.vue?vue&type=template&id=48839496&scoped=true&"
import script from "./SummaryContent.js?vue&type=script&lang=js&"
export * from "./SummaryContent.js?vue&type=script&lang=js&"
import style0 from "./SummaryContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SummaryContent.vue?vue&type=style&index=1&lang=css&"
import style2 from "./SummaryContent.vue?vue&type=style&index=2&id=48839496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48839496",
  null
  
)

export default component.exports